/** Live and help-center strings (docs/spec/modules/expenses.md); (unverified) copy follows the spec's choices. */
export const s = {
  pageTitle: "Expenses",
  reportTitle: "Reports",
  sidebar: "Expenses",
  teammates: "Teammates",
  searchTeammates: "Search teammates",
  show: "Show",
  statusActive: "Active",
  statusInactive: "Inactive",
  statusAll: "All",
  categoriesButton: "Expense categories",
  addExpense: "Add expense",
  thisWeek: "This week",
  lastWeek: "Last week",
  today: "Today",
  yesterday: "Yesterday",
  weekTotal: "Week total:",
  periodTotal: "Total:",
  dayTotal: "Total:",
  submitForApproval: "Submit for approval",
  submitTooltip: "Submit expenses for approval",
  pending: "Pending",
  approved: "Approved",
  rejected: "Rejected",
  withdrawPending: "Withdraw pending",
  submitChanges: "Submit changes",
  unsubmittedChanges: "Unsubmitted changes. Submit them to update approval request.",
  noProject: "(no project)",
  noNote: "-",
  edit: "Edit",
  delete: "Delete",
  actions: "Actions",
  lockedTooltip: "Approved expenses can't be edited",
  lockedDateTooltip: "This expense is locked",
  attachment: "Open receipt",
  billable: "Billable",
  nonBillable: "Non-billable",
  emptyTitle: "No expenses yet",
  emptyText: "Add your first expense by clicking Add expense",
  loadMore: "Load more",
  pleaseWait: "Please wait",
  created: "Expense successfully created.",
  updated: "Expense successfully updated.",
  deleted: "Expense successfully deleted.",
  undo: "Undo",
  restored: "Expense restored.",
  // Modal
  createExpense: "Create expense",
  editExpense: "Edit expense",
  teamMember: "Team member",
  date: "Date",
  project: "Project",
  selectProject: "Select project",
  searchProject: "Search Project or Client",
  noProjects: "No projects yet",
  noClient: "Without client",
  category: "Category",
  selectCategory: "Select category",
  searchCategories: "Search categories",
  createNewCategory: "Create new Category",
  amount: "Amount",
  enterAmount: "Enter amount",
  quantity: "Quantity",
  note: "Note",
  addNote: "Add note",
  yes: "Yes",
  fileAttachment: "File attachment",
  attachReceipt: "Attach receipt",
  removeReceipt: "Remove receipt",
  create: "Create",
  save: "Save",
  cancel: "Cancel",
  close: "Close",
  fileTooLarge: "File is too large. Max file size is 5MB.",
  fileType: "Unsupported file format",
  totalLine: (amount: string) => `Total: ${amount}`,
  // Categories
  createCategory: "Create expense category",
  editCategory: "Edit expense category",
  categoryName: "Category name",
  hasUnitPrice: "This expense has a unit price",
  unitPriceTooltip: "Expense amount will be calculated by multiplying unit price and number of units",
  amountCurrency: (cur: string) => `Amount (${cur})`,
  per: "per",
  unitName: "Unit name",
  unitPlaceholder: "Unit",
  categoriesTitle: "Expense categories",
  showActive: "Show active",
  showArchived: "Show archived",
  showAll: "Show all",
  searchByName: "Search by name",
  createNewCategoryButton: "Create new category",
  colName: "Name",
  colUnitPrice: "Unit price",
  unitPriceValue: (amount: string, unit: string) => `${amount} per ${unit}`,
  archive: "Archive",
  restore: "Restore",
  noCategories: "No categories yet",
  deleteCategoryTitle: "Delete category",
  deleteCategoryBody: (name: string) =>
    `Are you sure you want to delete ${name}? All expenses in this category will become uncategorized.`,
  categoryArchived: "Category archived",
  categoryRestored: "Category restored",
  categoryDeleted: "Category deleted",
  // Approval dialogs
  submitDialogTitle: "Submit for approval",
  submitChangesBody:
    "This action will apply your changes to the pending request. Click submit to confirm and proceed with the update.",
  timeLine: "Time: 00:00:00h",
  expensesLine: (amount: string) => `Expenses: ${amount}`,
  submit: "Submit",
  withdrawTitle: "Withdraw pending",
  withdrawBody: "Are you sure you want to withdraw your submission?",
  withdraw: "Withdraw",
  // Receipt viewer
  download: "Download",
  // Report
  expenseReport: "Expense report",
  timeReport: "Time report",
  teamReport: "Team report",
  detailed: "Detailed",
  filter: "Filter",
  team: "Team",
  client: "Client",
  task: "Task",
  categories: "Categories",
  status: "Status",
  currency: "Currency",
  applyFilter: "Apply filter",
  contains: "Contains",
  doesNotContain: "Doesn't contain",
  billableGroup: "Billable",
  approvalGroup: "Approval",
  invoicingGroup: "Invoicing",
  approvedOpt: "Approved",
  unapprovedOpt: "Unapproved",
  invoicedOpt: "Invoiced",
  uninvoicedOpt: "Uninvoiced",
  withoutNote: "Without note",
  noteContains: "Note contains",
  total: "Total:",
  billableTotal: "Billable:",
  export: "Export",
  savePdf: "Save as PDF",
  saveCsv: "Save as CSV",
  saveExcel: "Save as Excel",
  customize: "Customize",
  colDate: "Date",
  colProject: "Project",
  colCategory: "Category",
  colUser: "User",
  colNote: "Note",
  colAmount: "Amount",
  invoiced: "Invoiced",
  manuallyInvoiced: "Manually marked as invoiced",
  markInvoiced: "Mark as invoiced",
  markUninvoiced: "Mark as uninvoiced",
  bulkDelete: "Delete",
  deleteManyTitle: (n: number) => `Delete ${n} expenses?`,
  deleteManyBody: "Deleted expenses can be restored with Undo right after.",
  selectedCount: (n: number) => `${n} selected`,
  noData: "No data for this date range",
  exportSettings: "Detailed export settings",
  reportName: "Report name",
  reportNamePlaceholder: "Detailed name",
  selectAll: "Select all",
  visibleAll: "Visible in PDF, CSV and Excel",
  visibleCsv: "Visible only in CSV and Excel",
  visiblePdf: "Visible only in PDF",
  rtl: "Display text right-to-left",
  exportFields: {
    PROJECT: "Project",
    AMOUNT: (cur: string) => `Amount (${cur})`,
    TASK: "Task",
    USER: "User",
    CLIENT: "Client",
    NOTE: "Note",
    DATE: "Date",
    CATEGORY: "Category",
    BILLABLE: "Billable",
    EMAIL: "Email",
    UNITS: "No. of units",
    UNIT: "Unit",
    INVOICED: "Invoiced",
    INVOICE_ID: "Invoice ID",
    CREATED: "Date of creation",
    APPROVAL_DATE: "Date of approval",
    APPROVAL: "Approval",
    APPROVED_BY: "Approved by",
    USER_ID: "User's ID",
    EXPENSE_TOTAL: "Expense total",
    BILLABLE_TOTAL: "Billable total",
    RECEIPTS: "Receipts",
  },
  yesValue: "Yes",
  noValue: "No",
  errorGeneric: "Something went wrong",
} as const;
